export default {
  requests: {},
}
